import { apiClient } from './apiClient';

export async function getAll(params = {}) {
  const response = await apiClient.get('/waitlist-entries', params);
  return response;
}

export async function getById(id) {
  const response = await apiClient.get(`/waitlist-entries/${id}`);
  return response.data || null;
}

export async function create(entry) {
  const response = await apiClient.post('/waitlist-entries', entry);
  return response.data;
}

export async function update(id, data) {
  const response = await apiClient.put(`/waitlist-entries/${id}`, data);
  return response.data;
}

export async function remove(id) {
  await apiClient.del(`/waitlist-entries/${id}`);
}

export default { getAll, getById, create, update, remove };
